import { ESessionStorageKeys } from 'constants/enums';
import { webStorageUtil } from 'state/webStorage.state.service';

export const LANDING_URL_MAX_LENGTH = 2000;

export const captureLandingUrl = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (webStorageUtil.get(ESessionStorageKeys.LANDING_URL)) {
      return;
    }

    webStorageUtil.set(
      ESessionStorageKeys.LANDING_URL,
      window.location.href.slice(0, LANDING_URL_MAX_LENGTH)
    );
  } catch {
    /* sessionStorage unavailable — best effort */
  }
};

export const getLandingUrl = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return webStorageUtil.get(ESessionStorageKeys.LANDING_URL);
  } catch {
    return null;
  }
};
